module.exports = __webpack_public_path__ + "static/media/i7.6aafad0c.jpg";